export default __webpack_public_path__ + "img/3-f0bca791.png";